const styles = [
  {
    featureType: "administrative",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#444444",
      },
    ],
  },
  {
    featureType: "landscape",
    elementType: "all",
    stylers: [
      {
        color: "#f2f2f2",
      },
    ],
  },
  {
    featureType: "poi",
    elementType: "all",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "road",
    elementType: "all",
    stylers: [
      {
        saturation: -100,
      },
      {
        lightness: 45,
      },
    ],
  },
  {
    featureType: "road.highway",
    elementType: "all",
    stylers: [
      {
        visibility: "simplified",
      },
    ],
  },
  {
    featureType: "road.highway.controlled_access",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#f3863d",
      },
    ],
  },
  {
    featureType: "transit",
    elementType: "all",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "water",
    elementType: "all",
    stylers: [
      {
        color: "#30a7c1",
      },
      {
        visibility: "on",
      },
    ],
  },
  {
    featureType: "water",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#ffffff",
      },
    ],
  },
];

export default class {
  constructor() {
    this.apiKey = window.App.googleMapsApiKey;
    this.selector = ".js-map";
    this.mapOptions = {
      zoom: 14,
      disableDefaultUI: false,
      styles,
    };
  }

  init() {
    if (!document.querySelectorAll(".js-map").length) {
      return;
    }

    import("google-maps-api-loader").then((module) => {
      const GoogleMapsApiLoader = module.default;

      GoogleMapsApiLoader({
        libraries: ["places"],
        apiKey: this.apiKey,
      }).then(
        () => {
          this.google = window.google;

          [...document.querySelectorAll(this.selector)].forEach((element) => {
            this.render(element);
          });
        },
        (err) => {
          // eslint-disable-next-line
        console.error(err);
        },
      );
    });
  }

  render(el) {
    const markers = el.querySelectorAll(".marker");

    const args = { ...this.mapOptions };
    args.mapTypeId = this.google.maps.MapTypeId.ROADMAP;

    const zoom = $(el).data("zoom");

    if (zoom) {
      args.zoom = parseInt(zoom);
    }

    const map = new this.google.maps.Map(el, args);
    map.markers = [];

    [...markers].forEach((marker) => {
      this.addMarker(marker, map);
    });

    this.centerMap(map);

    this.google.maps.event.addDomListener(window, "resize", () => {
      this.google.maps.event.trigger(map, "resize");
      this.centerMap(map);
    });

    return map;
  }

  addMarker(data, map) {
    const marker = new this.google.maps.Marker({
      position: {
        lat: parseFloat(data.dataset.lat),
        lng: parseFloat(data.dataset.lng),
      },
      animation: this.google.maps.Animation.DROP,
      icon: {
        url: data.dataset.marker,
        size: new this.google.maps.Size(36, 54),
        anchor: new this.google.maps.Point(18, 54),
        scaledSize: new this.google.maps.Size(36, 54),
      },
      optimized: false,
      map,
    });

    map.markers.push(marker);
  }

  centerMap(map) {
    const bounds = new this.google.maps.LatLngBounds();

    map.markers.forEach((marker) => {
      bounds.extend(new this.google.maps.LatLng(marker.position.lat(), marker.position.lng()));
    });

    if (map.markers.length === 1) {
      map.setCenter(bounds.getCenter());
    } else {
      map.fitBounds(bounds);
    }
  }
}
